import Resources from "./resources";

export default Resources;
